import * as React from 'react'
import {
  Button, Box, Flex, TextButton, DropDown, Loading
} from '@binance/uikit'
import styled from 'styled-components'

const MenuWrap = styled(Flex)`
  a {
    text-decoration-line: none;
  }
`

const Logout = styled(Box)`
  padding: ${props => props.theme.space[3]}px 0;
  width: 100px;
  text-align: center;
  position: relative;
  cursor: pointer;
  .username {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid ${props => props.theme.colors.white};
    font-size: ${props => props.theme.fontSizes[4]}px;
    color: #fff;
  }

  &:hover {
    color: rgba(255, 255, 255, 0.7);
    .username {
      border: 1px solid rgba(255, 255, 255, 0.7);
    }
  }
  &:hover .btn {
    display: flex;
  }
  .btn {
    position: absolute;
    bottom: -40px;
    width: 98px;
    height: 36px;
    display: none;
    justify-content: center;
    align-items: center;
    z-index: 100;
    background: ${props => props.theme.colors.background};
  }
`

MenuWrap.defaultProps = {
  height: 50,
  alignItems: 'center'
}

export default class HeaderMenu extends React.PureComponent {
  render () {
    const {
      isLogin, urls, username, handleLogout, i18n
    } = this.props

    return (
      <MenuWrap>
        <Loading
          status={isLogin}
          width="125px"
          success={
            <DropDown
              tigger="hover"
              overlay={
                <Flex
                  height="36px"
                  alignItems="center"
                  width="100px"
                  bg="#1E2126"
                  justifyContent="center"
                >
                  <TextButton bg="transparent" onClick={handleLogout}>
                    {i18n['header-logout'] || 'Logout'}
                  </TextButton>
                </Flex>
              }
            >
              <Logout>
                <a className="username">{username.substr(0, 2)}</a>
              </Logout>
            </DropDown>
          }
          faild={
            <>
              <a href={(urls && urls.register) || '/'}>
                <Button width="72px" height="32px" color="black" bg="primary">
                  {i18n['header-register'] || 'Register'}
                </Button>
              </a>
            </>
          }
        />
      </MenuWrap>
    )
  }
}

HeaderMenu.defaultProps = {
  username: '',
  handleLogout: () => {}
}
